import { render, staticRenderFns } from "./AtendimentosPorPessoa.vue?vue&type=template&id=5a493132"
import script from "./AtendimentosPorPessoa.vue?vue&type=script&lang=js"
export * from "./AtendimentosPorPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports